import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AuthService from './services/authService';

// Layouts
import Admin from './layouts/Admin';
import Auth from './layouts/Auth';
import Staff from './layouts/Staff';

// CSS
import './App.css';

function App() {
  // Kiểm tra trạng thái đăng nhập để quyết định redirect mặc định
  const getDefaultRedirect = () => {
    const currentUser = AuthService.getCurrentUser();
    
    // Nếu đã đăng nhập và token còn hiệu lực
    if (currentUser && !AuthService.isTokenExpired()) {
      if (currentUser.role === 'staff') {
        return '/staff/orders';
      } else {
        return '/admin/dashboard';
      }
    }
    
    // Nếu token hết hạn, xóa thông tin đăng nhập
    if (currentUser && AuthService.isTokenExpired()) {
      AuthService.logout();
    }
    
    // Mặc định chuyển về trang login
    return '/auth/login';
  };

  return (
    <Routes>
      <Route path="/auth/*" element={<Auth />} />
      <Route path="/admin/*" element={<Admin />} />
      <Route path="/staff/*" element={<Staff />} />
      <Route path="/" element={<Navigate to={getDefaultRedirect()} replace />} />
    </Routes>
  );
}

export default App;
